// extracted by mini-css-extract-plugin
export default {"errorContainer":"StreamError_errorContainer--ooE","errorIcon":"StreamError_errorIcon--pH3"};